export const servicios = {
    text1: "Elenco delle richieste di servizio",
    text2: "Richieste effettuate dai tuoi clienti",
    text3: "Elenco delle richieste",
    text4: "Tutte",
    text5: "In sospeso",
    text6: "Approvate",
    text7: "Rifiutate",
    text8: "Pagate",
    text9: "Servizio",
    text10: "Cliente",
    text11: "Telefono",
    text12: "Creata",
    text13: "Stato",
    text14: "Vedi ordine",
    text15: "Richiesta di servizio.",
    text16: "Dati della richiesta",
    text17: "Data della richiesta:",
    text18: " alle",
    text19: "Informazioni sul servizio",
    text20: "Prezzo:",
    text21: "Prezzo per:",
    text22: "Categoria:",
    text23: "Fornitore:",
    text24: "Fornitore:",
    text25: "Servizio interno",
    text26: "Informazioni sul servizio",
    text27: "Servizio non trovato",
    text28: "Informazioni sul richiedente",
    text29: "Telefono:",
    text30: "Email:",
    text31: "Tipo di documento:",
    text32: "Numero del documento:",
    text33: "Chiudi",
    text34: "Rifiuta",
    text35: "Approva",
    text36: "Conferma pagamento",
    text37: "Rifiuta richiesta",
    text38: "Approva richiesta",
    text39: "Conferma il pagamento del richiedente",
    text40: "Sei sicuro di voler rifiutare la richiesta di servizio?",
    text41: "Contatta il richiedente del servizio prima di approvare la richiesta",
    text42: "Confermando il pagamento del richiedente, il processo sarà completato",
    text43: "Rifiuta",
    text44: "Approva richiesta",
    text45: "Ho già confermato il pagamento",
    text46: "Annulla",
    text47: "Aggiornato con successo.",

    // New labels

    p1: `Oggi`,
    p2: `Servizio richiesto`,
    p3: `Ospite`,
    p4: `Data della richiesta`,
    p5: `Non è ancora stata effettuata alcuna richiesta di servizio`,
    p6: `Non hai ancora configurato alcun servizio.`,
    p7: `Configura i servizi del tuo alloggio affinché i tuoi ospiti possano effettuare richieste`,
    p8: `Configura servizio`,
    p9: `Consulenza`,
    p10: `Scarta la richiesta di servizio`,
    p11: `Sei sicuro? I dati della richiesta andranno persi`,
    p12: `Scarta`,
    p13: `Richiesta di servizio eliminata con successo`,
    p14: "Carica fino a 3 foto del tuo servizio",
    p15: "Trascina e rilascia per caricare le foto",
    p16: "...oppure clicca per selezionare le foto dal tuo computer",
    p17: "Clicca per cercare un'immagine dalla tua galleria"
};
